// Mirrors the processor registry in the cashout-admin API (Domain/Processors.cs). Casing is
// load-bearing: vco.CardSites.ProcessorCode stores these values verbatim and the portal
// string-matches them.
enum Processor {
    SVS = "SVS",
    FISERV = "FISERV",
    Manual = "Manual"
}

export default Processor;
